import {API_URLS} from '@px/const/urls';
import {http} from '@px/helper/http';

export const marginApi = {
  marginAccountActivate() {
    return http.post(API_URLS.MARGIN_ACCOUNT_ACTIVATE, {});
  },
  borrow(params) {
    return http.post(API_URLS.MARGIN_BORROW, {params});
  },
  replay(params) {
    return http.post(API_URLS.MARGIN_REPAY, {params});
  },
  transfer(params) {
    return http.post(API_URLS.MARGIN_TRANSFER, {params});
  },
  transferPilot(params) {
    return http.post(API_URLS.TRANSFER_PILOT, {params});
  },
  getSysRemainingBorrow(query?) {
    return http.get(API_URLS.MARGIN_SYS_REMAINING_BORROW, {query});
  },
  getUtaSysRemainingBorrow(query?) {
    return http.get(API_URLS.MARGIN_SYS_REMAINING_BORROW_UTA, {query});
  },
  getGray() {
    return http.get(API_URLS.COMMON_GRAY, {});
  },
  getWallets(query = {}) {
    return http.get(API_URLS.MT_WALLETS, {query});
  },
};
